import { render, staticRenderFns } from "./onlyoffice.vue?vue&type=template&id=c31a93e8"
import script from "./onlyoffice.vue?vue&type=script&lang=js"
export * from "./onlyoffice.vue?vue&type=script&lang=js"
import style0 from "./onlyoffice.vue?vue&type=style&index=0&id=c31a93e8&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports